import React from 'react';

type UpfrontPricingType = {
	HasData: boolean;
	HasMemberData: boolean;
	MemberUpfrontPaymentAmount?: number | null;
	UpfrontPaymentAmount?: number | null;
	UpfrontPaymentPercentage?: number | null;
};

type FinanceInstallmentProps = {
	UpfrontPricing: UpfrontPricingType;
	UseUpfrontPricingAmounts: boolean;
	DeliveryPricingInPricePod: boolean;
	NewDayFinanceQuote: any;
};

export function FinanceInstallments({
	UpfrontPricing = {
		HasData: false,
		HasMemberData: false
	},
	UseUpfrontPricingAmounts,
	DeliveryPricingInPricePod,
	NewDayFinanceQuote,
}: FinanceInstallmentProps) {
	const financeTextFactory = () => {
		const upfrontCriteriaMet =
			UseUpfrontPricingAmounts && UpfrontPricing.HasData;

		let financeText = DeliveryPricingInPricePod
			? `from ${NewDayFinanceQuote.FormattedMonthlyPriceString} monthly* `
			: `or from ${NewDayFinanceQuote.FormattedMonthlyPriceString} monthly* `;

		if (upfrontCriteriaMet) {
			const formattedUpfrontPaymentAmount = UpfrontPricing.UpfrontPaymentAmount?.toFixed(
				2
			);

			financeText =
				financeText.slice(0, -2) +
				` plus \n £${formattedUpfrontPaymentAmount} upfront today*`;
		}

		return { financeText, upfrontCriteriaMet };
	};

	const { financeText, upfrontCriteriaMet } = financeTextFactory();

	return (
		<div
			className={upfrontCriteriaMet ? 'whitespace-pre-line' : ''}
			data-testid="finance-text-with-optional-upfront">
			{financeText}
			<span className="ico ico-chevron-right ico-lg" />
		</div>
	);
}
